import Vue from 'vue'
import axios from 'axios'
import Config from '../../Config/config'
var yuming = Config.host;

var HttpGet = (url, data, other)=>{
  data.token = sessionStorage.getItem("token")
  return new Promise((resolve, reject)=>{
    axios.get(yuming + url, data, {withCredentials: true})
    .then((success)=>{
      resolve(success)
    })
    .catch((error)=>{
      reject(error)
    })
  })
}

var HttpPost = (url, data={}, other)=>{
  data.token = sessionStorage.getItem("token")
  return new Promise((resolve, reject)=>{
    axios.post(yuming + url, data, {withCredentials: true})
    .then((success)=>{
      resolve(success)
    })
    .catch((error)=>{
      reject(error)
    })
  })
}

export default {
	yuming,
  HttpGet,
  HttpPost
}



// WEBPACK FOOTER //
// ./src/lib/js/axios.js